import { AlignTypes } from "@monorepo-web/components-library";
export const getLayouts = (benches) => {
    const columns = {
        'default': [
            {
                id: 'periodo',
                label: 'Período',
                freeze: true,
                align: AlignTypes.left,
                cellWidth: '325px',
            },
            {
                id: 'carteira',
                label: 'Carteira',
                align: AlignTypes.right,
                cellWidth: '275px',
            },
        ]
    };
    if (benches) {
        benches.forEach((val, i) => {
            columns['default'].push({
                id: `bench${i}`,
                label: val.toString(),
                align: AlignTypes.right,
                cellWidth: '200px',
            });
        });
    }
    return columns;
};
